<template>
  <v-dialog :value="true" hide-overlay max-width="1080px">
    <v-card class="insight-modal center">
      <div v-if="!insights">
        <v-progress-circular color="#1c1c1c" indeterminate />
      </div>
      <template v-else>
        <div class="modal-nav d-flex flex-column color-white">
          <div class="header-4 nav-title">Related Insights</div>
          <div
            class="modal-nav-cell text-2 color-grey ai-center"
            v-for="insight in insights.entries()"
            :key="insight[0]"
            v-bind:class="{ 'modal-nav-active': category === insight[0] }"
            @click="onClickNavCell(insight[0])"
          >
            {{ insight[0] }}
            <v-spacer />
            <div class="color-white bold">{{ insight[1].length }}</div>
          </div>
        </div>
        <div class="modal-content flex-1">
          <div class="flex-container">
            <div class="header-3 kor color-black modal-title">
              {{ category }}
            </div>
            <v-spacer />
            <v-btn icon color="#1c1c1c" large @click="closeModal">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="flex-container">
            <div class="text-3 modal-division">{{ division }}</div>
          </div>
          <div class="space-15" />
          <div class="flex-container ai-center">
            <div class="text-2">{{ `0${current + 1}` }}</div>
            <div class="text-2 color-grey ma-1">/</div>
            <div class="text-2 color-grey">{{ `0${pageLimit}` }}</div>
            <v-progress-linear
              class="progress-bar"
              :value="sliderValue"
              color="#1c1c1c"
              height="2px"
            ></v-progress-linear>
            <template>
              <div v-if="current > 0" class="btn-prev" @click="prev" />
              <div v-else class="btn-prev disabled" />
            </template>
            <template>
              <div
                v-if="current < pageLimit - 1"
                class="btn-next"
                @click="next"
              />
              <div v-else class="btn-next disabled" />
            </template>
            <v-btn text class="ma-1" @click="moveToInsights">
              <div class="subtitle-2">View All +</div>
            </v-btn>
          </div>
          <div class="space-15" />
          <swiper
            ref="insightSwiper"
            class="swiper-wrapper"
            :options="swiperOption"
            v-bind:class="{
              'last-slide': pageLimit > 1 && current === pageLimit - 1,
            }"
          >
            <swiper-slide
              v-for="insight in insights.get(category)"
              :key="insight.id"
              class="insight-wrapper"
            >
              <v-hover v-slot:default="{ hover }">
                <v-card
                  light
                  class="insight-card relative d-flex flex-column ai-center"
                  outlined
                  :elevation="hover ? 5 : 0"
                >
                  <div class="insight-image">
                    <v-img height="300px" :src="insight.thumbnail.url">
                      <v-fade-transition>
                        <v-img
                          v-if="hover"
                          height="300px"
                          :src="insight.cover.url"
                        />
                      </v-fade-transition>
                    </v-img>
                  </div>
                  <div class="insight-body-wrapper flex-1 d-flex flex-column">
                    <div class="flex-container flex-3">
                      <div class="insight-header">
                        <div
                          class="text-3 color-grey thin flex-1 flex-container ai-center"
                        >
                          {{
                            `${insight.category.name} > ${insight.division.name}`
                          }}
                        </div>
                        <div
                          class="text-1 insight-title bold color-black flex-1"
                        >
                          {{ parseTitle(insight.title) }}
                        </div>
                      </div>
                      <div class="insight-logo">
                        <img
                          v-if="insight.authorIcon.url"
                          class="insight-author-icon"
                          :src="insight.authorIcon.url"
                        />
                        <div
                          v-else
                          class="text-2 insight-author-text color-grey"
                        >
                          {{ insight.author }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="text-2 flex-2 thin color-black flex-container ai-center"
                    >
                      {{ parseSummary(insight.summary) }}
                    </div>
                  </div>
                </v-card>
              </v-hover>
            </swiper-slide>
          </swiper>
        </div>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data: () => ({
    insights: null,
    category: null,
    division: null,
    pageLimit: null,
    pageItems: null,
    current: 0,
    swiperOption: {
      slidesPerView: 3,
      spaceBetween: 10,
      centeredSlides: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    },
  }),
  computed: {
    sliderValue() {
      return ((this.current + 1) * 100) / this.pageLimit;
    },
    showInsightModal() {
      return this.$store.state.showInsightModal;
    },
    swiper() {
      return this.$refs.insightSwiper.swiper;
    },
  },
  methods: {
    async parseData() {
      const response = await this.$apollo.query({
        query: require("../graphql/GetPublishedInsights.gql"),
      });

      const ok = response.data.GetPublishedInsights.ok;
      if (!ok) {
        alert("서버 에러");
        return [];
      }
      const rawInsights = response.data.GetPublishedInsights.insights;

      const map = new Map();

      for (const insight of rawInsights) {
        const key = insight.category.name;
        const collection = map.get(key);
        if (collection) {
          collection.push(insight);
        } else {
          map.set(key, [insight]);
        }
      }

      let divisionString = "";
      map.get(this.category).forEach((item) => {
        divisionString += item.division.name + ", ";
      });
      this.division = divisionString
        .trim()
        .substring(0, divisionString.length - 2);

      this.current = 0;
      this.pageLimit = Math.ceil((map.get(this.category).length + 1) / 3);
      this.insights = map;
    },
    makePageItems() {
      if (!this.insights) return [];
      const pageItems = [];
      const limit = this.insights.get(this.category).length;
      for (var i = 0; i < this.pageLimit; i++) {
        let start = i * 3;
        let end = (i + 1) * 3;
        if (end < limit) end = limit;

        pageItems.push(this.insights.get(this.category).splice(start, end));
      }
      return pageItems;
    },
    getCurrentPage() {
      if (!this.insights) return [];
      let start = this.current * 3;
      let end = (this.current + 1) * 3;
      const limit = this.insights.get(this.category).length;
      if (end > limit) {
        return this.insights.get(this.category).splice(start, limit);
      } else {
        return this.insights.get(this.category).splice(start, end);
      }
    },

    parseTitle(title) {
      if (title.length < 25) {
        return title;
      }
      return title.substring(0, 22) + "...";
    },

    parseSummary(summary) {
      if (summary.length < 50) {
        return summary;
      }
      return summary.substring(0, 47) + "...";
    },
    onClickNavCell(category) {
      this.category = category;
      let divisionString = "";
      this.insights.get(category).forEach((item) => {
        divisionString += item.division.name + ", ";
      });
      this.division = divisionString
        .trim()
        .substring(0, divisionString.length - 2);
      this.current = 0;
      this.pageLimit = Math.ceil((this.insights.get(category).length + 1) / 3);
    },
    moveToInsights() {
      this.$router.push("/insights");
      this.$router.go(0);
    },
    next() {
      this.current += 1;
      this.swiper.slideNext();
    },
    prev() {
      this.current -= 1;
      this.swiper.slidePrev();
    },
    closeModal() {
      this.$store.state.showInsightModal = false;
    },
  },
  mounted() {
    this.category = this.$store.state.selectedInsightCategory;
    this.parseData();
  },
};
</script>

<style scoped>
.insight-modal {
  height: 800px;
  z-index: 4;
  width: 100%;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.modal-nav {
  background: #1c1c1c;
  width: 250px;
  height: 100%;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.nav-title {
  padding: 40px 20px;
}

.modal-division {
  margin-top: 10px;
  margin-left: 3px;
}

.modal-content {
  background: white;
  height: 100%;
  max-width: 830px;
  padding: 20px;
  overflow: hidden;
}

.modal-nav-cell {
  width: 100%;
  padding: 5px 20px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  transition: 0.3s ease-in-out;
  cursor: pointer;
}

.modal-nav-cell:hover {
  color: white;
  font-weight: bold;
  background: #333;
  transition: 0.3s ease-in-out;
}

.modal-nav-active {
  color: white;
  font-weight: bold;
  background: #333;
  cursor: default;
}

.modal-title {
  padding-top: 10px;
  font-size: 28px;
  line-height: 1.2;
}

.progress-bar {
  margin-left: 40px;
  width: 500px;
}

.swiper-wrapper {
  width: 120%;
  height: 600px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.insight-wrapper {
  width: 33.3%;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.insight-card {
  width: 95%;
  height: 95%;
  margin: auto;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  transition: 0.3s ease-in-out;
}

.insight-body-wrapper {
  width: 90%;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.insight-header {
  height: 100%;
  flex: 2;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}

.insight-image {
  width: 100%;
  height: 300px;
}

.insight-logo {
  height: 100%;
  -ms-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  padding-left: 20px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
}

.insight-author-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.insight-title {
  width: 100%;
  word-break: keep-all;
  font-size: 20px;
}

.last-slide {
  margin-left: -20%;
}

.insight-summary {
  margin-top: 30px;
}
</style>
